export const attorneyForumsTabs = [
  {
    tab: "Home",
    path: "/attorney/forums",
  },
  {
    tab: "My Posts",
    path: "/attorney/forums/my-posts",
  },
  // {
  //   tab: "My Posts for Bids",
  //   path: "/attorney/forums/bids",
  // },
  {
    tab: "Following",
    path: "/attorney/forums/following",
  },
];

export const clientForumsTabs = [
  {
    tab: "Home",
    path: "/client/forums/all-posts",
  },
  {
    tab: "My Posts",
    path: "/client/forums/my-posts",
  },
  {
    tab: "Following",
    path: "/client/forums/following",
  },
];
export const forumsTabs = [
  {
    tab: "Home",
    path: "/forums/all-posts",
  },
  {
    tab: "My Posts",
    path: "/forums/my-posts",
  },
  {
    tab: "Following",
    path: "/forums/following",
  },
];
export const documentsTabs = [
  {
    tab: "Documents",
    path: "/documents/documents",
  },
  {
    tab: "Templates",
    path: "/documents/templates",
  },
];
